"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDayOfWeek = void 0;
const dayjs = require("dayjs");
const toDayOfWeek = (date) => {
    const day = dayjs(date).format("dddd");
    // pluralize
    return `${day}s`;
};
exports.toDayOfWeek = toDayOfWeek;
